import React from "react";
// import JSONPretty from "react-json-pretty";
import { connect } from "react-redux";
import { Input } from "@revvsales/components";
import {
  RevvForm,
  CustomSelect,
  ErrorMessages,
} from "../../../../commonComponents";

import {
  CustomFieldInitialValuesMap,
  CustomFieldComponentRules,
  CustomFieldComponentMessages,
} from "./CustomFieldRulesMap";
import { RateOptions } from "../../../../constants/customDynamicMeta";
// Actions Imports
import { DocumentTemplateActions } from "../../../../actions";

const {
  toggleDynamicFieldView,
  setMetaFieldValues,
  setFlagForDefault,
  metaValidStatus,
  setFlagForCommonFields,
} = DocumentTemplateActions;

class RateField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDefaultValue: this._getShowDefaultValue(props),
      rateFieldValues: this._getDataForPrepopulate(props),
    };
  }

  _getShowDefaultValue = propsData => {
    let returnData = false;
    if (
      propsData.meta &&
      propsData.meta.default &&
      propsData.meta.default.rateValue !== ""
    ) {
      returnData = true;
    }
    return returnData;
  };

  _getDataForPrepopulate = propsData => {
    let returnData = JSON.parse(
      JSON.stringify(CustomFieldInitialValuesMap.RATE),
    );
    if (propsData.meta && propsData.meta.default) {
      returnData = {
        options: this._prepareOptions(propsData.meta.options),
        rateValue: propsData.meta.default.rateValue,
        rateUom: this._prepareOptionsForrateUom(propsData.meta.default.rateUom),
      };
    }
    return returnData;
  };

  _prepareOptionsForrateUom = data => {
    let returnData = {};
    if (data) {
      returnData = { name: data, id: data };
    }
    return returnData;
  };

  _prepareOptions = data => {
    const returnData = [];
    if (data && data.length > 0) {
      data.forEach(element => {
        returnData.push({ name: element, id: element });
      });
    }
    return returnData;
  };

  _toggleDefaultValue = () => {
    const { showDefaultValue } = this.state;
    this.setState({ showDefaultValue: !showDefaultValue });
  };

  resetState = () => {
    this.props.setFlagForDefault(true);
    this.props.metaValidStatus(false);
    const { showDefaultValue } = this.state;
    if (showDefaultValue === true) {
      this.setState({ showDefaultValue: false });
    }
  };

  render() {
    const { showDefaultValue, rateFieldValues } = this.state;
    return (
      <React.Fragment>
        <RevvForm
          initialFormValue={rateFieldValues}
          customFieldName="RATE"
          customFieldComponentRules={CustomFieldComponentRules}
          customFieldComponentMessages={CustomFieldComponentMessages}
          validateOnChange={false}
          render={formProps => {
            const {
              handleChange,
              handleChangeByName,
              // handleBlur,
              messages,
              touched,
              errors,
              values,
              isValid,
            } = formProps;
            const allInAll = {
              isValid,
              messages,
              touched,
              errors,
              values,
            };
            if (values.options.length === 0) {
              this.resetState();
            }
            if (
              !showDefaultValue &&
              (values.rateValue !== "" || values.rateUom !== undefined)
            ) {
              values.rateUom = "";
              values.rateValue = "";
            }
            console.debug("allInAllhhh", allInAll);
            const options = [];
            for (let d = 0; d < values.options.length; d += 1) {
              options.push(values.options[d].name);
            }
            const data = {
              options,
              default: {
                rateValue: values.rateValue,
                rateUom:
                  values.rateUom !== undefined &&
                  values.rateUom.name !== undefined
                    ? values.rateUom.name
                    : "",
              },
            };
            console.debug("data", data);
            if (
              data.options.length > 0 &&
              !showDefaultValue &&
              data.default.rateValue === "" &&
              data.default.rateUom === ""
            ) {
              this.props.setFlagForDefault(false);
            } else if (
              (data.options.length > 0 &&
                showDefaultValue &&
                data.default.rateValue === "") ||
              data.default.rateUom === ""
            ) {
              this.props.setFlagForDefault(true);
              this.props.metaValidStatus(false);
            } else if (
              data.options.length > 0 &&
              showDefaultValue &&
              data.default.rateValue !== "" &&
              data.default.rateUom !== ""
            ) {
              this.props.setFlagForDefault(true);
              this.props.metaValidStatus(true);
            }
            this.props.setMetaFieldValues(data);

            return (
              <React.Fragment>
                <span className="revvform-label">
                  Rate
                  <span className="requiredwitherr-input">*</span>
                </span>
                <CustomSelect
                  id="options"
                  name="options"
                  value={values.options}
                  getOptionLabel={({ name }) => name}
                  options={RateOptions}
                  isMulti
                  _handleChangeInSelect={value =>
                    handleChangeByName(value, "options")
                  }
                  required
                />
                {values.options.length > 0 && (
                  <React.Fragment>
                    <div className="dynamicfieldcustom-default-container">
                      <Input
                        id="checkbox"
                        type="checkbox"
                        data-test="RateField-default"
                        checked={showDefaultValue}
                        onChange={() => this._toggleDefaultValue()}
                        className="dynamicfieldcustom-footer-input errorborder"
                      />
                      <span className="dynamicfieldcustom-footer-checkboxinput">
                        This has a default value
                      </span>
                    </div>
                  </React.Fragment>
                )}

                {showDefaultValue && values.options.length > 0 && (
                  <div>
                    <span className="revvform-label">
                      Default value
                      <span className="requiredwitherr-input"> *</span>
                    </span>
                    <Input
                      autoFocus
                      id="rateValue"
                      name="rateValue"
                      type="number"
                      data-test="RateField-default"
                      value={values && values.rateValue}
                      placeholder="Enter field default value"
                      className="dynamicfieldcustom-footer-input errorborder"
                      onChange={value => handleChange(value)}
                      // onBlur={value => handleBlur(value)}
                      required
                    />
                    {messages.default && (
                      <ErrorMessages messages={messages.default.required} />
                    )}
                    <span className="revvform-label">
                      Default Unit
                      <span className="requiredwitherr-input">*</span>
                    </span>
                    <CustomSelect
                      id="rateUom"
                      name="rateUom"
                      value={values.rateUom}
                      getOptionLabel={({ name }) => name}
                      options={values.options}
                      _handleChangeInSelect={value =>
                        handleChangeByName(value, "rateUom")
                      }
                      required
                    />
                  </div>
                )}
              </React.Fragment>
            );
          }}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    meta,
  } = state.TemplateStore.dynamicFields.selectedDynamicFieldForUpdate;
  return {
    meta,
  };
};

const mapDispatchToProps = {
  toggleDynamicFieldView,
  setFlagForDefault,
  metaValidStatus,
  setMetaFieldValues,
  setFlagForCommonFields,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RateField);



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/DynamicFieldComponents/RateField.js